<template>
  <section class="app-documents">
    <v-container>
      <services-list :data="services"></services-list>
    </v-container>
  </section>
</template>

<script>
import { services } from "@/models/service";
import ServicesList from "@/components/ServicesList";

export default {
  metaInfo: {
    title: "Ouvidoria - Central de Serviços"
  },
  components: {
    ServicesList
  },
  data: () => {
    return {
      services: [services[2]]
    };
  }
};
</script>

<style>
</style>